import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { Link, browserHistory } from 'react-router';
import moment from 'moment';
import _ from 'lodash';
import {
	createAsset,
	editAsset,
	saveRebatesAndClaims,
} from '../../../../redux/actions';

import { routes } from '../../../../redux/api/routes';
let { s3BucketAPIBaseURL } = routes;

class CreateEditRebatesAndForms extends Component {
	constructor(props) {
        super(props);
        this.state = {
			confirmationMessage: '',
			errorMessage: '',
			rebatesAndClaimForm: {
				params: {
					docId: '',
					displayName: '',
					docGroup: '',
					docName: '',
					createdBy: '',
					createdDate: moment().format('MM/DD/YYYY'),
					updatedDate: moment().format('MM/DD/YYYY'),
				},
				errors: {
					displayNameError: '',
					docGroupError: '',
					docNameError: '',
				}
			},
			whichOperation: '',

			fileUploadStatusMessage: '',
			fileUploadStatus: false,
			fileUploadErrorMessage: ''
        }
    }

	handleFileUpload(e) {
        e.preventDefault();
        var self = this,
            files = e.target.files;
        if (files.length > 0) {
			// if(files[0].size/1000 > 500) {
			// 	self.setState({
			// 		fileUploadErrorMessage: 'Please select file size upto 500KB',
			// 		fileUploadStatusMessage: '',
			// 		rebatesAndClaimForm: {
			// 			...self.state.rebatesAndClaimForm,
			// 			errors: {
			// 				...self.state.rebatesAndClaimForm.errors,
			// 				docNameError: '',
			// 			}
			// 		}
			// 	})
			// } else {
	            self.setState({
	                fileUploadStatusMessage: 'Please wait until file is uploading.....',
	                fileUploadStatus: true,
	                fileUploadErrorMessage: ''
	            });
	            var file = files[0],
	                reader = new FileReader();
	            reader.addEventListener('loadend', function (e) {
					const { userDetails } = self.props.state.user;
	                fetch(s3BucketAPIBaseURL, {
	                    method: "POST",
						headers: {
	                        'Content-Type': 'application/json',
							"Authorization": `${userDetails.jwt}${userDetails.sso}`,
	                    },
	                    body: JSON.stringify({
	                        name:  `CustomerNet/rebatesAndClaims/${file.name}`,
	                        type: file.type
	                    })
	                }).then(function (response) {
	                    return response.json();
	                }).then(function (json) {
						self.setState({
							rebatesAndClaimForm: {
								...self.state.rebatesAndClaimForm,
								params: {
									...self.state.rebatesAndClaimForm.params,
									docName: file.name,
									docS3URL: json.uploadURL,
								},
								errors: {
									...self.state.rebatesAndClaimForm.errors,
									docNameError: '',
								}
							}
	                    });
	                    return fetch(json.uploadURL, {
	                        method: "PUT",
	                        body: new Blob([reader.result], {
	                            type: file.type
	                        })
	                    })
	                }).then(function () {
	                    self.setState({
	                        fileUploadStatusMessage: 'File is uploaded successfully.',
	                        fileUploadStatus: false,
	                        fileUploadErrorMessage: ''
	                    });
	                });
	            });
	            reader.readAsArrayBuffer(file);
			// }
        } else {
            self.setState({
                fileUploadStatusMessage: '',
                fileUploadStatus: false,
                fileUploadErrorMessage: ''
            });
        }
    }

	updateParams(formName, event) {
		//Reseting Errors on change
		const self = this;
		const name = event.target.name;
		self.setState({
			[formName]: {
				...self.state[formName],
				params: {
					...self.state[formName].params,
					[name]: event.target.value
				}
			}
		}, () => {
			if(self.state[formName].errors[name + 'Error']) {
				self.setState({
					[formName]: {
						...self.state[formName],
						errors: {
							...self.state[formName].errors,
							[name+'Error']: ''
						},
					},
				});
			}
		});
	}

	// event for close dialog
	handleDialog(dialog, flag, event) {
		event && event.preventDefault();
		this.setState({
			['show'+dialog]: false
		}, () => {
			this.setState({
				['show'+dialog]: flag
			})
		})
	}

	componentWillMount() {
		const self = this,
			{ user, homepage } = self.props.state,
			{ editRebateAsset, rebatesAndClaims } = homepage;
		const whichOperation = self.props.params.whichOperation;
		//If there is no existing data available in store, then make service call and get data and then do needful
		if(whichOperation === 'edit' && !editRebateAsset) {
			browserHistory.push('/siteManagement/rebatesAndClaimForms');
		} else if(whichOperation === 'create') {
			let docId = 0;
			rebatesAndClaims.responseObject.forEach(itm => {
				if(parseInt(itm.docId, 10) > docId) {
					docId = parseInt(itm.docId, 10);
				}
			});
			docId += 1;
			self.setState({
				whichOperation,
				rebatesAndClaimForm: {
					...self.state.rebatesAndClaimForm,
					params: {
						...self.state.rebatesAndClaimForm.params,
						createdBy: user.userDetails.sso,
						docId: docId.toString(),
					}
				}
			});
		} else {	// In case of edit asset
			self.setState({
				whichOperation,
				rebatesAndClaimForm: {
					...self.state.rebatesAndClaimForm,
					params: JSON.parse(JSON.stringify(editRebateAsset)),
				}
			});
		}
	}

	handleSubmit(event) {
		const self = this;
		const { params, errors } = self.state.rebatesAndClaimForm;
		let formError = false;
		//Reset all errors
		for(var key in errors) {
            if(!params[key.replace("Error","")]) {
                errors[key] = 'error';
                formError = true;
            } else {
				errors[key] = '';
			}
        }
		self.setState({
			params,
			errors,
			serviceCallCompleted: false
		}, () => {
			if(!formError) {
				const payload = JSON.parse(JSON.stringify(self.state.rebatesAndClaimForm.params));
				delete payload.docS3URL;
				// make service call accordingly
				if(self.state.whichOperation === 'create') {
					self.props.createAsset(payload, 'requestType=rebatesAndClaims', response => {
						if(response.status && response.responseObject) {
							const { rebatesAndClaims } = JSON.parse(JSON.stringify(self.props.state.homepage));
							rebatesAndClaims.responseObject.push(response.responseObject);
							self.props.saveRebatesAndClaims(rebatesAndClaims);
							self.setState({
								serviceCallCompleted: true
							});
						} else {
							browserHistory.push('/error');
						}
					});
				} else {
					self.props.editAsset(payload, 'requestType=rebatesAndClaims', response => {
						if(response.status && response.responseObject) {
							const { rebatesAndClaims } = JSON.parse(JSON.stringify(self.props.state.homepage));
							rebatesAndClaims.responseObject.forEach(itm => {
								if(itm.docId === response.responseObject.docId) {
									itm = response.responseObject;
								}
							});
							self.props.saveRebatesAndClaims(rebatesAndClaims);
							self.setState({
								serviceCallCompleted: true
							});
						} else {
							browserHistory.push('/error');
						}
					});
				}
			}
		});
	}

	removeKey(url) {
		let path = url.indexOf("?AWSAccessKeyId=") !== -1 ? url.substring(0, url.indexOf("?AWSAccessKeyId=")) : url;
		return path;
	}

    render() {
		const self = this;
		const { rebatesAndClaimForm: { params, errors } } = self.state;
        return (
            <div>
				<div className="push">
					<h1 className="pageTitle">Rebates and Claim Forms</h1>
				</div>
				{this.state.errorMessage?<p className="red bold push">{this.state.errorMessage}</p>:null}
				{this.state.confirmationMessage?<p className="bold push">{this.state.confirmationMessage}</p>:null}
				{this.state.serviceCallCompleted && <div>
					{this.state.whichOperation === 'create' && <p className="bold red">Document has been created successfully.</p>}
					{this.state.whichOperation === 'edit' && <p className="bold red">Document has been updated successfully.</p>}
				</div>}
				<div className="largePush">
					<p className="bold red" id="errorMessage">{this.state.errorMessage}</p>
					<table style={{width: '100%'}} className="formTableTypeA createOrderTableA">
						<tbody>
							<tr>
								<td className="first-column">Display Name</td>
								<td className="middle-column">
									<input disabled={this.state.serviceCallCompleted} className={errors.displayNameError} defaultValue={params.displayName} type="text" name="displayName" onChange={this.updateParams.bind(this, 'rebatesAndClaimForm')} />
								</td>
								<td className={errors.docNameError} rowSpan={ 7 }>
									<input disabled={this.state.serviceCallCompleted} accept="application/pdf" onChange={this.handleFileUpload.bind(this)} type="file" /> &nbsp;
									<br />
									{errors.docNameError && <p className="bold red">Please select a image</p>}
									{this.state.fileUploadStatus === false && params.docS3URL &&
										<div className="bold image-thumb">
											<a href={this.removeKey(params.docS3URL)} target="_blank">
												{params.docName}
											</a>
										</div>
									}
									{this.state.fileUploadErrorMessage?<p className="red"><b>{this.state.fileUploadErrorMessage}</b></p>:null}
									{this.state.fileUploadStatusMessage?<p className="bold">{this.state.fileUploadStatusMessage}</p>:null}
								</td>
							</tr>
							<tr>
								<td className="first-column">Document Type</td>
								<td className="middle-column">
									<select
										disabled={this.state.serviceCallCompleted}
										className={errors.docGroupError}
										defaultValue={params.docGroup}
										name="docGroup"
									 	onChange={this.updateParams.bind(this, 'rebatesAndClaimForm')}
									>
										<option value="">-- Select --</option>
										<option value="Rebate">Rebate</option>
										<option value="Claim Form">Claim Form</option>
									</select>
								</td>
							</tr>
							{!this.state.serviceCallCompleted && <tr>
								<td />
								<td className="middle-column">
		                            <input type="button" onClick={this.handleSubmit.bind(this)} className="blueButton uppercase" defaultValue="Submit" />
								</td>
							</tr>}
						</tbody>
					</table>
					{this.state.serviceCallCompleted && <div>
						<p><Link to={"/siteManagement/rebatesAndClaimForms"}>Return to Previous Screen</Link></p>
						<div className="clear" />
					</div>}
					<p>
						<Link to="/siteManagement">Back to Site Management</Link>
					</p>
				</div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	createAsset: (payload, hybridQueryParams, callback) => dispatch(createAsset(payload, hybridQueryParams, callback)),
	editAsset: (payload, hybridQueryParams, callback) => dispatch(editAsset(payload, hybridQueryParams, callback)),
	saveRebatesAndClaims: (data) => dispatch(saveRebatesAndClaims(data)),
});

CreateEditRebatesAndForms = connect(mapStateToProps, mapDispatchToProps)(CreateEditRebatesAndForms);
export default CreateEditRebatesAndForms;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/SiteManagement/RebatesAndClaimForms/createEditRebatesAndForms.js